import Serializer from 'umg-ember-backend/serializers/application';

export default class ExternalValueSerializer extends Serializer {
  attrs = {
    position: 'cmsPosition',
  };
}
